/**
 *  Date    : 2020/2/29
 *  Author  : Weilin
 *  Declare : QQAuthorize
 */

import authUtils from '../authUtils';

const { DEFAULT_QQ_OFFICIAL_ACCOUNTS_ID, domain } = authUtils.config;
const wechatApi = authUtils.wechatApi;
const readerCenterApi = authUtils.readerCenterApi;

class QqAuthorize {
  constructor({
    query,
    snsapiBase,
    defaultAuthorize
  }) {
    this.query = query || {};
    this.snapsis = snsapiBase || false;
    this.defaultAuthorize = defaultAuthorize || false; // 是否需要进入时授权
  }

  checkLogged() {
    const { wechatUserId, userType } = authUtils.getCookieUser();
    // 是否真实用户
    return userType === authUtils.CONSTANT.USER_TYPE_REGULAR && !!wechatUserId;
  }

  /**
   * 检查是否存在openid
   * @returns {boolean}
   */
  checkOpenid() {
    return !!this.query.openid;
  }

  /**
   * 通过openid获取用户信息
   */
  getByOpenid() {
    const data = {
      openId: this.query.openid,
      officialAccountsId: DEFAULT_QQ_OFFICIAL_ACCOUNTS_ID
    };
    return readerCenterApi.getUserInfoByOpenId(data);
  }

  /**
   * 进入默认授权
   */
  enterAuthorize() {
    return this.defaultAuthorize;
  }

  /**
   * 是否有code信息
   * @returns {boolean}
   */
  checkCode() {
    return !!this.query.code;
  }

  /**
   * 通过code获取用户信息
   * @returns Promise
   */
  getByCode() {
    const { code, phone } = this.query;
    const data = {
      code,
      phone,
      officialAccountsId: DEFAULT_QQ_OFFICIAL_ACCOUNTS_ID,
      redirectUrl: QqAuthorize.getRedirectUrl()
    };
    return wechatApi.qqAuthorizeUser(data);
  }

  /**
   * 发起授权
   */
  forward() {
    //重定向到QQ授权界面
    const baseUrl = `${window.location.origin}/wechat/qqAuth/forward?`;
    return window.location = `${baseUrl}${authUtils.json2params({
      officialAccountsId: DEFAULT_QQ_OFFICIAL_ACCOUNTS_ID,
      redirectUrl: QqAuthorize.getRedirectUrl(),
      snsapiBase: this.snapsis
    })}`;
  }

  /**
   *
   * redirectUrl
   * @returns {string}
   */
  static getRedirectUrl() {
    // 环境常量对应二级域名
    const ENV = { DEV: 'chubanyun.me', TEST: 'raysgo.com', UAT: 'raysyun.com', PRO: '5rs.me' };
    const getDomain = (url = '') => {
      // 默认测试域名
      let payUrl = ENV.PRO;
      Object.values(ENV).forEach((item) => {
        if(url.includes(item)) {
          payUrl = item;
        }
      });
      return payUrl;
    };
    return `https://weixin${DEFAULT_QQ_OFFICIAL_ACCOUNTS_ID}.${getDomain(domain)}/author?path=${encodeURIComponent(QqAuthorize.getAuthorizeUrl())}`;
  }

  static getAuthorizeUrl() {
    const href = window.location.href, search = window.location.search;
    if(search.indexOf('code') > -1) {
      const query = authUtils.params2json(search.slice(1));
      delete query.code;
      return (
        window.location.origin + window.location.pathname + '?' + authUtils.json2params(query)
      );
    } else {
      return href;
    }
  }
}

export default QqAuthorize;
